import React, { useContext, useState, useEffect } from "react";
import { Box, TextField, Tab, CircularProgress } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import RichTextEditor from "./RichTextEditor";
import FileUploadArea from "./common/FileUploadArea";
import { pathJoinUrl } from "@smfa/utils/src";
import { AppContext } from "../context";
import {
  addCommunityBanner,
  getCommunityBanner,
  addCommunityPlanning,
  getCommunityPlanning,
} from "../actions/committee.actions";

const Educationmeetingplanningcommittee = () => {
  const { storage } = useContext(AppContext);
  const [value, setValue] = useState("1");
  const [loader, setLoader] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const handleChange = (event, newValue) => {
    setSuccessMsg("");
    setErrorMsg("");
    setLoader(false);

    setValue(newValue);
  };

  var addAboutBanner_default = {
    banner_section_id: 0,
    banner_image: "",
    banner_image_name: "",
    banner_image_error: false,
    banner_image_mob: "",
    banner_image_mob_name: "",
    banner_image_mob_error: false,
    banner_title: "",
    banner_title_maxlenth: 50,
    banner_title_error: false,
  };
  const [addAboutBanner, setAboutBanner] = useState(addAboutBanner_default);

  const [deskimage, setDeskImage] = useState("");
  const onImageChange = (event) => {
    setSuccessMsg("");
    setErrorMsg("");

    var custInfo = { ...addAboutBanner };
    if (event.target.files[0]) {
      setDeskImage(URL.createObjectURL(event.target.files[0]));
      custInfo.banner_image = event.target.files[0];
      custInfo.banner_image_name = event.target.files[0].name;
      custInfo.banner_image_error = false;
      setAboutBanner(custInfo);
    }
  };

  const [mobimage, setMobImage] = useState("");
  const onMobImageChange = (event) => {
    setSuccessMsg("");
    setErrorMsg("");

    var custInfo = { ...addAboutBanner };
    if (event.target.files && event.target.files[0]) {
      setMobImage(URL.createObjectURL(event.target.files[0]));
      custInfo.banner_image_mob = event.target.files[0];
      custInfo.banner_image_mob_name = event.target.files[0].name;
      custInfo.banner_image_mob_error = false;
      setAboutBanner(custInfo);
    }
  };

  var addMembershipBenefit_default = {
    section_id: 0,
    section_image: "",
    section_image_name: "",
    section_image_error: false,
    section_image_mob: "",
    section_image_mob_name: "",
    section_image_mob_error: false,
    section_title: "",
    section_title_maxlenth: 50,
    section_title_error: false,
    chair: "",
    chair_maxlenth: 80,
    chair_error: false,
    vice_chair: "",
    vice_chair_maxlenth: 80,
    vice_chair_error: false,
    news_leeter_editor: "",
    news_leeter_editor_maxlenth: 80,
    news_leeter_editor_error: false,
    description: "",
    description_error: false,
  };

  const [addMembershipBenefit, setMembershipBenefit] = useState(
    addMembershipBenefit_default,
  );

  const [benefitsection_image, setBenefitImage] = useState("");
  const onImageChangeBenfit = (event) => {
    setSuccessMsg("");
    setErrorMsg("");

    var custInfo = { ...addMembershipBenefit };
    if (event.target.files[0]) {
      setBenefitImage(URL.createObjectURL(event.target.files[0]));
      custInfo.section_image = event.target.files[0];
      custInfo.section_image_name = event.target.files[0].name;
      custInfo.section_image_error = false;
      setMembershipBenefit(custInfo);
    }
  };

  const clearBannerUpload = (field, clearPreview) => {
    clearPreview("");
    setAboutBanner((previous) => ({
      ...previous,
      [field]: "",
      [`${field}_name`]: "",
    }));
  };

  const clearBenefitUpload = () => {
    setBenefitImage("");
    setMembershipBenefit((previous) => ({
      ...previous,
      section_image: "",
      section_image_name: "",
    }));
  };

  const [addData, setVal] = useState("");
  const handleChangeck = (e, editor) => {
    setSuccessMsg("");
    setErrorMsg("");

    if (editor !== "") {
      var custInfo = { ...addMembershipBenefit };
      custInfo.description = editor.getData();
      custInfo.description_error = false;
      setMembershipBenefit(custInfo);
      const data = editor.getData();
      setVal(data);
    } else {
      setVal("");
    }
  };

  const addMembershipBenefitInfo = (event) => {
    setSuccessMsg("");
    setErrorMsg("");

    var custInfo = { ...addMembershipBenefit };
    if (event.target.name === "section_title") {
      if (
        event.target.value.length <= addMembershipBenefit.section_title_maxlenth
      ) {
        custInfo.section_title = event.target.value;
        custInfo.section_title_error = false;
      }
    }

    if (event.target.name === "chair") {
      if (event.target.value.length <= addMembershipBenefit.chair_maxlenth) {
        custInfo.chair = event.target.value;
        custInfo.chair_error = false;
      }
    }

    if (event.target.name === "vice_chair") {
      if (
        event.target.value.length <= addMembershipBenefit.vice_chair_maxlenth
      ) {
        custInfo.vice_chair = event.target.value;
        custInfo.vice_chair_error = false;
      }
    }

    if (event.target.name === "news_leeter_editor") {
      if (
        event.target.value.length <=
        addMembershipBenefit.news_leeter_editor_maxlenth
      ) {
        custInfo.news_leeter_editor = event.target.value;
        custInfo.news_leeter_editor_error = false;
      }
    }

    setMembershipBenefit(custInfo);
  };

  const submitLocationMembershipBenefit = () => {
    // return false;
    setLoader(true);
    setSuccessMsg("");
    setErrorMsg("");
    var custInfo = { ...addMembershipBenefit };

    if (addMembershipBenefit.banner_title === "") {
      document.getElementById("section_title").focus();
      custInfo.section_title_error = true;
      //  setErrorMsg('Please Enter Operating Unit!');
      setMembershipBenefit(custInfo);

      setLoader(false);
      return false;
    }

    if (addMembershipBenefit.chair === "") {
      document.getElementById("chair").focus();
      custInfo.chair_error = true;
      //  setErrorMsg('Please Enter Operating Unit!');
      setMembershipBenefit(custInfo);

      setLoader(false);
      return false;
    }

    if (addMembershipBenefit.vice_chair === "") {
      document.getElementById("vice_chair").focus();
      custInfo.vice_chair_error = true;
      //  setErrorMsg('Please Enter Operating Unit!');
      setMembershipBenefit(custInfo);

      setLoader(false);
      return false;
    }

    if (addMembershipBenefit.news_leeter_editor === "") {
      document.getElementById("news_leeter_editor").focus();
      custInfo.news_leeter_editor_error = true;
      //  setErrorMsg('Please Enter Operating Unit!');
      setMembershipBenefit(custInfo);

      setLoader(false);
      return false;
    }

    if (addMembershipBenefit.description === "") {
      document.getElementById("description").focus();
      custInfo.description_error = true;
      //  setErrorMsg('Please Enter Operating Unit!');
      setMembershipBenefit(custInfo);

      setLoader(false);
      return false;
    }

    if (addMembershipBenefit.benefit_details_forth === "") {
      document.getElementById("benefit_details_forth").focus();
      custInfo.benefit_details_forth_error = true;
      //  setErrorMsg('Please Enter Operating Unit!');
      setMembershipBenefit(custInfo);

      setLoader(false);
      return false;
    }

    if (addMembershipBenefit.benefit_details_fifth === "") {
      document.getElementById("benefit_details_fifth").focus();
      custInfo.benefit_details_fifth_error = true;
      //  setErrorMsg('Please Enter Operating Unit!');
      setMembershipBenefit(custInfo);

      setLoader(false);
      return false;
    }

    if (addMembershipBenefit.benefit_details_six === "") {
      document.getElementById("benefit_details_six").focus();
      custInfo.benefit_details_six_error = true;
      //  setErrorMsg('Please Enter Operating Unit!');
      setMembershipBenefit(custInfo);

      setLoader(false);
      return false;
    }

    const formData = new FormData();
    formData.append("section_id", addMembershipBenefit.section_id);
    formData.append("section_image", addMembershipBenefit.section_image);
    formData.append("section_title", addMembershipBenefit.section_title);
    formData.append("chair", addMembershipBenefit.chair);
    formData.append("vice_chair", addMembershipBenefit.vice_chair);
    formData.append(
      "news_leeter_editor",
      addMembershipBenefit.news_leeter_editor,
    );
    formData.append("description", addMembershipBenefit.description);

    if (addMembershipBenefit.section_id === 0) {
      addCommunityPlanning(formData)
        .then((res1) => {
          if (res1.data.status === true) {
            setSuccessMsg(
              "Education and meeting planning Committee  Addedd Successfully!",
            );
            setLoader(false);
            setTimeout(function () {
              setLoader(false);
              setSuccessMsg("");
            }, 3000);
          } else {
            setMembershipBenefit(addMembershipBenefit_default);
            setErrorMsg(res1.data.message);
            setLoader(false);
          }
        })
        .catch((error) => {
          setMembershipBenefit(addMembershipBenefit_default);
          setLoader(false);
          setErrorMsg("Something went wrong,please try again!");
        });
    } else {
      addCommunityPlanning(formData)
        .then((res1) => {
          if (res1.data.status === true) {
            setSuccessMsg(
              "Education and meeting planning Committee Updated Successfully!",
            );
            setLoader(false);

            setTimeout(function () {
              setLoader(false);
              setSuccessMsg("");
            }, 3000);
          } else {
            setErrorMsg("Something went wrong,please try again!");
            setLoader(false);
          }
        })
        .catch((error) => {
          setLoader(false);
          setErrorMsg("Something went wrong,please try again!");
        });
    }
  };

  useEffect(() => {
    getCommunityBanner().then((res) => {
      var locInfo = { ...addAboutBanner };
      if (res.data.status === true) {
        locInfo.banner_section_id = res.data.data.banner_section_id;
        locInfo.banner_title = res.data.data.banner_title;
        locInfo.banner_image_name = res.data.data.banner_image;
        locInfo.banner_image_mob_name = res.data.data.banner_image_mob;
        setAboutBanner(locInfo);
        if (res.data.data.banner_image !== null) {
          setDeskImage(
            pathJoinUrl(storage[0].imageEndUrl, res.data.data.banner_image),
          );
        }
        if (res.data.data.banner_image_mob !== null) {
          setMobImage(
            pathJoinUrl(storage[0].imageEndUrl, res.data.data.banner_image_mob),
          );
        }
      } else {
      }
    });
    getCommunityPlanning().then((res) => {
      var locInfo = { ...addMembershipBenefit };
      if (res.data.status === true) {
        locInfo.section_id = res.data.data.section_id;
        locInfo.section_title = res.data.data.section_title;
        locInfo.chair = res.data.data.chair;
        locInfo.vice_chair = res.data.data.vice_chair;
        locInfo.news_leeter_editor = res.data.data.news_leeter_editor;
        locInfo.description = res.data.data.description;
        setVal(locInfo.description);
        locInfo.section_image_name = res.data.data.section_image;
        setMembershipBenefit(locInfo);
        if (res.data.data.section_image !== null) {
          setBenefitImage(
            pathJoinUrl(storage[0].imageEndUrl, res.data.data.section_image),
          );
        }
      } else {
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const addAboutBannerInfo = (event) => {
    setSuccessMsg("");
    setErrorMsg("");

    var custInfo = { ...addAboutBanner };
    if (event.target.name === "banner_title") {
      if (event.target.value.length <= addAboutBanner.banner_title_maxlenth) {
        custInfo.banner_title = event.target.value;
        custInfo.banner_title_error = false;
      }
    }

    setAboutBanner(custInfo);
  };

  const submitLocation = () => {
    // return false;
    setLoader(true);
    setSuccessMsg("");
    setErrorMsg("");
    var custInfo = { ...addAboutBanner };

    if (addAboutBanner.banner_title === "") {
      document.getElementById("banner_title").focus();
      custInfo.banner_title_error = true;
      //  setErrorMsg('Please Enter Operating Unit!');
      setAboutBanner(custInfo);

      setLoader(false);
      return false;
    }

    const formData = new FormData();
    formData.append("banner_section_id", addAboutBanner.banner_section_id);
    formData.append("banner_image_mob", addAboutBanner.banner_image_mob);
    formData.append("banner_image", addAboutBanner.banner_image);
    formData.append("banner_title", addAboutBanner.banner_title);

    if (addAboutBanner.banner_section_id === 0) {
      addCommunityBanner(formData)
        .then((res1) => {
          if (res1.data.status === true) {
            setSuccessMsg("Join Added Successfully!");
            setLoader(false);
            setTimeout(function () {
              setLoader(false);
              setSuccessMsg("");
            }, 3000);
          } else {
            setAboutBanner(addAboutBanner_default);
            setErrorMsg(res1.data.message);
            setLoader(false);
          }
        })
        .catch((error) => {
          setAboutBanner(addAboutBanner_default);
          setLoader(false);
          setErrorMsg("Something went wrong, please try again!");
        });
    } else {
      addCommunityBanner(formData)
        .then((res1) => {
          if (res1.data.status === true) {
            setSuccessMsg("Banner Updated Successfully!");
            setLoader(false);

            setTimeout(function () {
              setLoader(false);
              setSuccessMsg("");
            }, 3000);
          } else {
            setErrorMsg("Something went wrong, please try again!");
            setLoader(false);
          }
        })
        .catch((error) => {
          setLoader(false);
          setErrorMsg("Something went wrong, please try again!");
        });
    }
  };
  return (
    <>
      <div className="content">
        <div className="body-inner-sec">
          <div className="container-fluid">
            <div className="row">
              <div className="banner-inner-bdy-sec tab-sec-smfa">
                <Box sx={{ width: "100%", typography: "body1" }}>
                  <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                      <TabList
                        onChange={handleChange}
                        aria-label="lab API tabs example"
                      >
                        <Tab label="Add Banner" value="1" />
                        <Tab label="Committee Details" value="2" />
                      </TabList>
                    </Box>
                    <TabPanel value="1">
                      <div className="banner-inner-bdy-sec tab-sec-smfa bene-margin-bot">
                        <div className="row">
                          <div className="col-md-4">
                            <div className="about-banner-sec">
                              <div className="form-secs inner-form-secs vali-forms">
                                <Box
                                  component="form"
                                  sx={{
                                    "& > :not(style)": { m: 1, width: "25ch" },
                                  }}
                                  noValidate
                                  autoComplete="off"
                                >
                                  <TextField
                                    id="banner_title"
                                    label="Title"
                                    variant="standard"
                                    onChange={addAboutBannerInfo}
                                    name="banner_title"
                                    value={addAboutBanner.banner_title}
                                    error={addAboutBanner.banner_title_error}
                                    helperText={` ${addAboutBanner.banner_title_error === true ? "Please enter Title!" : ""}`}
                                  />

                                  <div className="charcter-sec">
                                    {addAboutBanner.banner_title_maxlenth -
                                      addAboutBanner.banner_title.length ===
                                    0 ? (
                                      <>
                                        <span
                                          className="char-limit"
                                          style={{ color: "#FF0000" }}
                                        >
                                          Max Character Limit reached{" "}
                                        </span>
                                      </>
                                    ) : (
                                      <>
                                        <p className="max-charact-sec">
                                          Max Characters:&nbsp;
                                          {addAboutBanner.banner_title_maxlenth -
                                            addAboutBanner.banner_title.length}
                                        </p>
                                      </>
                                    )}
                                  </div>
                                </Box>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-5 banner-uplod-secs">
                            <FileUploadArea
                              title="Add Banner Image For Desktop"
                              description={
                                <>
                                  Best image Resolution: 1920px X 836px
                                  <br />
                                  Supported files types: JPG, JPEG & PNG
                                </>
                              }
                              previewUrl={deskimage}
                              fileName={addAboutBanner.banner_image_name}
                              onChange={onImageChange}
                              deleteRequest={{
                                resource: "community-banner",
                                id: addAboutBanner.banner_section_id,
                                field: "banner_image",
                              }}
                              onRemove={() =>
                                clearBannerUpload("banner_image", setDeskImage)
                              }
                              accept=".png,.jpg,.jpeg"
                            />
                          </div>
                          <div className="col-md-5 banner-uplod-secs">
                            <FileUploadArea
                              title="Add Banner Image For Mobile"
                              description={
                                <>
                                  Best image Resolution: 400px X 350px
                                  <br />
                                  Supported files types: JPG, JPEG & PNG
                                </>
                              }
                              previewUrl={mobimage}
                              fileName={addAboutBanner.banner_image_mob_name}
                              onChange={onMobImageChange}
                              deleteRequest={{
                                resource: "community-banner",
                                id: addAboutBanner.banner_section_id,
                                field: "banner_image_mob",
                              }}
                              onRemove={() =>
                                clearBannerUpload(
                                  "banner_image_mob",
                                  setMobImage,
                                )
                              }
                              accept=".png,.jpg,.jpeg"
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <div
                              className="button-sec"
                              style={{ marginTop: "30px" }}
                            >
                              <button
                                type="button"
                                className="btn btn-login btn-update"
                                onClick={(e) => {
                                  submitLocation();
                                  e.preventDefault();
                                }}
                              >
                                Update
                                {loader === true ? (
                                  <CircularProgress
                                    style={{
                                      width: "15px",
                                      height: "15px",
                                      marginLeft: "5px",
                                      color: "white",
                                    }}
                                  />
                                ) : (
                                  ""
                                )}
                              </button>
                              <div className="validate-sec">
                                {successMsg !== "" ? (
                                  <div className="">
                                    <p className="succ-msg">{successMsg}</p>
                                  </div>
                                ) : (
                                  <div className="">
                                    <p
                                      className="succ-msg"
                                      style={{ visibility: "hidden" }}
                                    >
                                      Banner Updated Successfully!
                                    </p>
                                  </div>
                                )}
                                {errorMsg !== "" ? (
                                  <div className="">
                                    <p className="error-msg">{errorMsg}</p>
                                  </div>
                                ) : (
                                  <div className="">
                                    <p
                                      className="error-msg"
                                      style={{ visibility: "hidden" }}
                                    >
                                      Something went wrong,please try again!
                                    </p>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </TabPanel>
                    <TabPanel value="2">
                      <div className="banner-inner-bdy-sec tab-sec-smfa bene-margin-bot">
                        <div className="row">
                          <div className="col-md-4">
                            <div className="about-banner-sec">
                              <div className="form-secs inner-form-secs  vali-forms">
                                <Box
                                  component="form"
                                  sx={{
                                    "& > :not(style)": { m: 1, width: "25ch" },
                                  }}
                                  noValidate
                                  autoComplete="off"
                                >
                                  <TextField
                                    id="section_title"
                                    label="Title"
                                    variant="standard"
                                    onChange={addMembershipBenefitInfo}
                                    name="section_title"
                                    value={addMembershipBenefit.section_title}
                                    error={
                                      addMembershipBenefit.section_title_error
                                    }
                                    helperText={` ${addMembershipBenefit.section_title_error === true ? "Please enter Title!" : ""}`}
                                  />
                                  <div className="charcter-sec">
                                    {addMembershipBenefit.section_title_maxlenth -
                                      addMembershipBenefit.section_title
                                        .length ===
                                    0 ? (
                                      <>
                                        <span
                                          className="char-limit"
                                          style={{ color: "#FF0000" }}
                                        >
                                          Max Character Limit reached{" "}
                                        </span>
                                      </>
                                    ) : (
                                      <>
                                        <p className="max-charact-sec">
                                          Max Characters:&nbsp;
                                          {addMembershipBenefit.section_title_maxlenth -
                                            addMembershipBenefit.section_title
                                              .length}
                                        </p>
                                      </>
                                    )}
                                  </div>
                                </Box>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="row" style={{ marginTop: "5px" }}>
                          <div className="col-md-4">
                            <div className="about-banner-sec">
                              <div className="form-secs inner-form-secs  vali-forms">
                                <Box
                                  component="form"
                                  sx={{
                                    "& > :not(style)": { m: 1, width: "25ch" },
                                  }}
                                  noValidate
                                  autoComplete="off"
                                >
                                  <TextField
                                    id="chair"
                                    label="Chair Name"
                                    variant="standard"
                                    name="chair"
                                    onChange={addMembershipBenefitInfo}
                                    value={addMembershipBenefit.chair}
                                    error={addMembershipBenefit.chair_error}
                                    helperText={` ${addMembershipBenefit.chair_error === true ? "Please enter Paragraph!" : ""}`}
                                  />
                                  <div className="charcter-sec">
                                    {addMembershipBenefit.chair_maxlenth -
                                      addMembershipBenefit.chair.length ===
                                    0 ? (
                                      <>
                                        <span
                                          className="char-limit"
                                          style={{ color: "#FF0000" }}
                                        >
                                          Max Character Limit reached{" "}
                                        </span>
                                      </>
                                    ) : (
                                      <>
                                        <p className="max-charact-sec">
                                          Max Characters:&nbsp;
                                          {addMembershipBenefit.chair_maxlenth -
                                            addMembershipBenefit.chair.length}
                                        </p>
                                      </>
                                    )}
                                  </div>
                                </Box>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="about-banner-sec">
                              <div className="form-secs inner-form-secs  vali-forms">
                                <Box
                                  component="form"
                                  sx={{
                                    "& > :not(style)": { m: 1, width: "25ch" },
                                  }}
                                  noValidate
                                  autoComplete="off"
                                >
                                  <TextField
                                    id="vice_chair"
                                    label="Vice Chair"
                                    variant="standard"
                                    name="vice_chair"
                                    onChange={addMembershipBenefitInfo}
                                    value={addMembershipBenefit.vice_chair}
                                    error={
                                      addMembershipBenefit.vice_chair_error
                                    }
                                    helperText={` ${addMembershipBenefit.vice_chair_error === true ? "Please enter Details One!" : ""}`}
                                  />
                                  <div className="charcter-sec">
                                    {addMembershipBenefit.vice_chair_maxlenth -
                                      addMembershipBenefit.vice_chair.length ===
                                    0 ? (
                                      <>
                                        <span
                                          className="char-limit"
                                          style={{ color: "#FF0000" }}
                                        >
                                          Max Character Limit reached{" "}
                                        </span>
                                      </>
                                    ) : (
                                      <>
                                        <p className="max-charact-sec">
                                          Max Characters:&nbsp;
                                          {addMembershipBenefit.vice_chair_maxlenth -
                                            addMembershipBenefit.vice_chair
                                              .length}
                                        </p>
                                      </>
                                    )}
                                  </div>
                                </Box>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="about-banner-sec">
                              <div className="form-secs inner-form-secs  vali-forms">
                                <Box
                                  component="form"
                                  sx={{
                                    "& > :not(style)": { m: 1, width: "25ch" },
                                  }}
                                  noValidate
                                  autoComplete="off"
                                >
                                  <TextField
                                    id="news_leeter_editor"
                                    label="Newsletter Editor"
                                    variant="standard"
                                    name="news_leeter_editor"
                                    onChange={addMembershipBenefitInfo}
                                    value={
                                      addMembershipBenefit.news_leeter_editor
                                    }
                                    error={
                                      addMembershipBenefit.news_leeter_editor_error
                                    }
                                    helperText={` ${addMembershipBenefit.news_leeter_editor_error === true ? "Please enter Details Two!" : ""}`}
                                  />
                                  <div className="charcter-sec">
                                    {addMembershipBenefit.news_leeter_editor_maxlenth -
                                      addMembershipBenefit.news_leeter_editor
                                        .length ===
                                    0 ? (
                                      <>
                                        <span
                                          className="char-limit"
                                          style={{ color: "#FF0000" }}
                                        >
                                          Max Character Limit reached{" "}
                                        </span>
                                      </>
                                    ) : (
                                      <>
                                        <p className="max-charact-sec">
                                          Max Characters:&nbsp;
                                          {addMembershipBenefit.news_leeter_editor_maxlenth -
                                            addMembershipBenefit
                                              .news_leeter_editor.length}
                                        </p>
                                      </>
                                    )}
                                  </div>
                                </Box>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-6">
                            <FileUploadArea
                              title="Image"
                              description={
                                <>
                                  Best image Resolution: 225px X 237px
                                  <br />
                                  Supported files types: JPG, JPEG & PNG
                                </>
                              }
                              previewUrl={benefitsection_image}
                              fileName={addMembershipBenefit.section_image_name}
                              onChange={onImageChangeBenfit}
                              deleteRequest={{
                                resource: "community-planning",
                                id: addMembershipBenefit.section_id,
                                field: "section_image",
                              }}
                              onRemove={clearBenefitUpload}
                              accept=".png,.jpg,.jpeg"
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <div className="answer-secs">
                              <h2>Details</h2>
                              <RichTextEditor
                                data={addData}
                                onChange={handleChangeck}
                              />

                              <p
                                style={{
                                  marginBottom: "0px",
                                  marginTop: "8px",
                                }}
                              >
                                {addMembershipBenefit.description_error ===
                                true ? (
                                  <span className="ckvalid">Enter details</span>
                                ) : (
                                  <span
                                    className="ckvalid"
                                    style={{ visibility: "hidden" }}
                                  >
                                    Enter details
                                  </span>
                                )}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <div
                              className="button-sec"
                              style={{ marginTop: "30px" }}
                            >
                              <button
                                type="button"
                                className="btn btn-login btn-update"
                                onClick={(e) => {
                                  submitLocationMembershipBenefit();
                                  e.preventDefault();
                                }}
                              >
                                Update
                                {loader === true ? (
                                  <CircularProgress
                                    style={{
                                      width: "15px",
                                      height: "15px",
                                      marginLeft: "5px",
                                      color: "white",
                                    }}
                                  />
                                ) : (
                                  ""
                                )}
                              </button>
                              <div className="validate-sec">
                                {successMsg !== "" ? (
                                  <div className="">
                                    <p className="succ-msg">{successMsg}</p>
                                  </div>
                                ) : (
                                  <div className="">
                                    <p
                                      className="succ-msg"
                                      style={{ visibility: "hidden" }}
                                    >
                                      Banner Updated Successfully!
                                    </p>
                                  </div>
                                )}
                                {errorMsg !== "" ? (
                                  <div className="">
                                    <p className="error-msg">{errorMsg}</p>
                                  </div>
                                ) : (
                                  <div className="">
                                    <p
                                      className="error-msg"
                                      style={{ visibility: "hidden" }}
                                    >
                                      Something went wrong, please try again!
                                    </p>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </TabPanel>
                  </TabContext>
                </Box>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Educationmeetingplanningcommittee;
